(function(undefined) {
    var window = this || (0, eval)('this'),
        document = window['document'],
        navigator = window['navigator'],
        jQuery = window["jQuery"],
        JSON = window["JSON"];

    (function(factory) {
        if (typeof define === 'function' && define['amd']) {
            define(['exports', 'require'], factory);
        } else if (typeof exports === 'object' && typeof module === 'object') {
            factory(module['exports'] || exports);
        } else {
            factory(window['atlas'] = {});
        }
    }(function(atlasExports, amdRequire) {
        var atlas = typeof atlasExports !== 'undefined' ? atlasExports : {};
        var internals = {}

var BrandingModel;

BrandingModel = (function() {
  function BrandingModel(options) {
    options = $.extend(options, {});
    this.controlUrl = options.controlUrl;
    this.portalLogoUrl = "" + options.controlUrl + options.portalLogoUrl;
    this.mobileIconUrl = "" + options.controlUrl + options.mobileIconUrl;
    this.favIconUrl = "" + options.controlUrl + options.faviconUrl;
    this.cssUrl = "" + options.controlUrl + options.satelliteCSSUrl;
    this.controlName = options.controlName;
    this.headerBackgroundColor = options.headerBackgroundColor;
    if (options.controlUserProfileUrl) {
      this.controlUserProfileUrl = "" + options.controlUrl + options.controlUserProfileUrl;
    }
  }

  return BrandingModel;

})();

var SupportModel;

SupportModel = (function() {
  function SupportModel(options) {
    options = $.extend(options, {});
    this.chatServiceUrl = options.chatServiceUrl;
    this.supportEmail = options.supportEmail;
    this.supportPhone = options.supportPhone;
    this.supportRequestUrl = options.supportRequestUrl;
    this.featureRequestUrl = options.featureRequestUrl;
    this.knowledgeBaseUrl = options.knowledgebaseUrl;
    this.knowledgeBaseSearchUrl = options.knowledgebaseSearchUrl;
  }

  return SupportModel;

})();

var AccountSwitcherViewModel;

AccountSwitcherViewModel = (function() {
  function AccountSwitcherViewModel() {
    this.loadingAccounts = ko.observable(true);
    this.failedLoadingAccounts = ko.observable(false);
    this.accounts = ko.observableArray([]);
    this.currentAccountAlias = ko.observable('');
  }

  return AccountSwitcherViewModel;

})();

atlas.ajax = function(urlOrOptions, options) {
  var jqxhr;
  if (typeof urlOrOptions === 'object') {
    options = urlOrOptions;
  } else {
    options = options || {};
    options.url = urlOrOptions;
  }
  options.type = (options.type || 'GET').toUpperCase();
  if (options.data) {
    if (options.type !== 'GET' && options.type !== 'OPTIONS' && options.type !== 'HEAD') {
      options.contentType = options.contentType || 'application/json';
    }
    if (options.contentType === 'application/json' && typeof options.data !== 'string') {
      options.data = JSON.stringify(options.data);
    }
  }
  if (!options.noBearerToken) {
    options.headers = options.headers || {};
    options.headers['Authorization'] = options.headers['Authorization'] || ("Bearer " + (internals.authContext().bearerToken));
  }
  jqxhr = jQuery.ajax(options);
  return jQuery.extend(jqxhr, {
    aborted: function(func) {
      if (func) {
        this.fail((function(_this) {
          return function(xhr, textStatus, textReason) {
            if (!xhr.getAllResponseHeaders()) {
              return func(xhr, textStatus, textReason);
            }
          };
        })(this));
      }
      return this;
    },
    failed: function(func) {
      if (func) {
        this.fail((function(_this) {
          return function(xhr, textStatus, textReason) {
            if (xhr.getAllResponseHeaders()) {
              return func(xhr, textStatus, textReason);
            }
          };
        })(this));
      }
      return this;
    }
  });
};

var Authentication,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Authentication = (function() {
  var getOrCreateLoginWindow, getSamlConnection, hasSamlConnection, isForceSamlUser, isLoginWindowShown;

  getOrCreateLoginWindow = function() {
    var loginWindow;
    loginWindow = $('#signinOverlay');
    if (loginWindow.length < 1) {
      loginWindow = $('<div id="signinOverlay"></div>');
      $('body').append(loginWindow);
    }
    loginWindow.attr('data-bind', '{ template: displayTemplateName }');
    return loginWindow;
  };

  isLoginWindowShown = function() {
    return $('#signinOverlay').length > 0 && $('#signinOverlay').is(':visible');
  };

  getSamlConnection = function(connections) {
    var samlConnections;
    samlConnections = ko.unwrap(connections).filter(function(conn) {
      return conn.strategy === 'samlp';
    });
    return samlConnections[0];
  };

  hasSamlConnection = function(connections) {
    return !!getSamlConnection(ko.unwrap(connections));
  };

  isForceSamlUser = function(connections) {
    return ko.unwrap(connections).length === 1 && !!getSamlConnection(ko.unwrap(connections));
  };

  Authentication.prototype.setAuthContext = function(context) {
    if (this.authContext === void 0) {
      this.authContext = ko.observable(context);
    }
    this.authContext(context);
  };

  Authentication.prototype.clearAuthContextAndLocalStorage = function() {
    internals.localStorage.removeAll();
    return this.setAuthContext({
      username: void 0,
      bearerToken: void 0
    });
  };

  Authentication.prototype.clearUsernameAndConnections = function() {
    this.username('');
    this.password('');
    this.controlLoginInErrors.showAllMessages(false);
    this.rootAccountAlias('');
    return this.connectionTypes([]);
  };

  Authentication.prototype.getConnectionTypesForUser = function() {
    if (this.getConnectionTypeErrors().length > 0) {
      return this.getConnectionTypeErrors.showAllMessages();
    } else {
      this.gettingConnectionTypes(true);
      return jQuery.ajax({
        url: this.env.controlBaseUrl + "/api/authContext/user/" + (this.username())
      }).then((function(_this) {
        return function(data) {
          internals.localStorage.storeRootBrandingSupportInfo(data.branding, data.support);
          _this.rootAccountAlias(data.accountId);
          _this.connectionTypes(data.connections);
          if (isForceSamlUser(data.connections)) {
            return _this.loginUsingSaml();
          } else {
            _this.brandingModel(new BrandingModel(data.branding));
            _this.supportModel(new SupportModel(data.support));
            return _this.gettingConnectionTypes(false);
          }
        };
      })(this)).fail(function() {
        console.error('unable to fetch login options for user');
        return this.gettingConnectionTypes(false);
      });
    }
  };

  function Authentication(options) {
    this.logout = bind(this.logout, this);
    this.login = bind(this.login, this);
    this.showLoginWindow = bind(this.showLoginWindow, this);
    this.loginUsingSaml = bind(this.loginUsingSaml, this);
    this.loginUsingControl = bind(this.loginUsingControl, this);
    this.getConnectionTypesForUser = bind(this.getConnectionTypesForUser, this);
    this.clearUsernameAndConnections = bind(this.clearUsernameAndConnections, this);
    this.clearAuthContextAndLocalStorage = bind(this.clearAuthContextAndLocalStorage, this);
    this.setAuthContext = bind(this.setAuthContext, this);
    this.env = options.env;
    this.state = options.returnUrl;
    this.onLogin = options.onLogin;
    this.onLogout = options.onLogout;
    this.auth0 = new Auth0({
      domain: this.env.auth0Domain,
      clientID: this.env.auth0ClientID,
      callbackURL: options.callbackURL,
      responseType: 'token'
    });
    this.connectionTypes = ko.observableArray();
    this.rootAccountAlias = ko.observable();
    this.brandingModel = ko.observable(new BrandingModel());
    this.supportModel = ko.observable(new SupportModel());
    this.username = ko.observable();
    this.username.extend({
      required: {
        params: true,
        message: "username is required."
      }
    });
    this.password = ko.observable();
    this.password.extend({
      required: {
        params: true,
        message: "password is required."
      }
    });
    this.controlLoginInErrors = ko.validation.group([this.username, this.password]);
    this.controlLoginInFailed = ko.observable(false);
    this.controlLoginInFailedMessage = ko.observable('');
    this.getConnectionTypeErrors = ko.validation.group([this.username]);
    this.domainCheckComplete = ko.observable(true);
    this.processingLogin = ko.observable(false);
    this.gettingConnectionTypes = ko.observable(false);
    this.forgotPasswordHref = ko.pureComputed((function(_this) {
      return function() {
        return (_this.brandingModel().controlUrl) + "/auth/lost";
      };
    })(this));
    this.userHasSamlConnection = ko.pureComputed((function(_this) {
      return function() {
        return !!hasSamlConnection(_this.connectionTypes());
      };
    })(this));
    this.displayTemplateName = ko.pureComputed((function(_this) {
      return function() {
        if (!_this.domainCheckComplete()) {
          return 'atlas.domainCheck';
        }
        if (_this.connectionTypes().length < 1 || _this.gettingConnectionTypes()) {
          return 'atlas.fetchOptions';
        } else {
          return 'atlas.signIn';
        }
      };
    })(this));
    this.getConnectionTypesButtonText = ko.pureComputed((function(_this) {
      return function() {
        if (_this.gettingConnectionTypes()) {
          return 'fetching sign in options';
        } else {
          return 'Next';
        }
      };
    })(this));
  }

  Authentication.prototype.loginUsingControl = function() {
    if (!this.connectionTypes().some(function(c) {
      return c.name === 'Authentication-Service';
    })) {
      return;
    }
    if (this.controlLoginInErrors().length < 1) {
      this.processingLogin(true);
      return this.auth0.login({
        connection: 'Authentication-Service',
        username: this.username(),
        password: this.password(),
        scope: 'openid nickname',
        state: this.state
      }, (function(_this) {
        return function(err) {
          if (err.message) {
            _this.controlLoginInFailedMessage(err.message);
          } else {
            _this.controlLoginInFailedMessage('An error has occured.');
          }
          _this.controlLoginInFailed(true);
          return _this.processingLogin(false);
        };
      })(this));
    } else {
      return this.controlLoginInErrors.showAllMessages();
    }
  };

  Authentication.prototype.loginUsingSaml = function() {
    var samlConnection;
    this.processingLogin(true);
    samlConnection = getSamlConnection(this.connectionTypes);
    if (samlConnection) {
      return this.auth0.login({
        connection: samlConnection.name,
        'fwd.authnContext': this.rootAccountAlias(),
        scope: 'openid nickname',
        state: this.state
      }, (function(_this) {
        return function(err) {
          console.error("failed SAML login: " + err);
          return _this.processingLogin(false);
        };
      })(this));
    }
  };

  Authentication.prototype.showLoginWindow = function() {
    var node;
    if (!isLoginWindowShown()) {
      node = getOrCreateLoginWindow();
      return ko.applyBindings(this, node[0]);
    }
  };

  Authentication.prototype.login = function() {
    var auth0SignInHash, localStorageSSOData, resultDeferred;
    resultDeferred = $.Deferred();
    auth0SignInHash = this.auth0.parseHash(window.location.hash);
    if (auth0SignInHash) {
      this.auth0.getProfile(auth0SignInHash.idToken, (function(_this) {
        return function(err, auth0Details) {
          internals.localStorage.storeSSOInfo({
            token: auth0SignInHash.idToken,
            auth0Details: auth0Details
          });
          _this.setAuthContext({
            bearerToken: auth0SignInHash.idToken,
            username: auth0Details.nickname
          });
          if (_this.onLogin) {
            _this.onLogin(_this.authContext());
          }
          resultDeferred.resolve(_this.authContext);
          return window.location.href = auth0SignInHash.state;
        };
      })(this));
    } else {
      localStorageSSOData = internals.localStorage.getSSOInfo();
      this.auth0.getSSOData((function(_this) {
        return function(err, auth0SSOData) {
          if (auth0SSOData.sso) {
            if (localStorageSSOData && localStorageSSOData.auth0Details.user_id === auth0SSOData.lastUsedUserID) {
              _this.setAuthContext({
                bearerToken: localStorageSSOData.token,
                username: localStorageSSOData.auth0Details.nickname
              });
              if (_this.onLogin) {
                _this.onLogin(_this.authContext());
              }
              return resultDeferred.resolve(_this.authContext);
            } else {
              return _this.auth0.login({
                scope: 'openid nickname',
                state: _this.state
              });
            }
          } else {
            if (_this.onLogout) {
              _this.onLogout();
            }
            _this.showLoginWindow();
            _this.domainCheckComplete(false);
            return jQuery.ajax({
              url: _this.env.controlBaseUrl + "/api/authContext/host/" + window.location.hostname
            }).then(function(data) {
              if (_this.isForceSamlUser(data.connections)) {
                internals.localStorage.storeRootBrandingSupportInfo(data.branding, data.support);
                _this.rootAccountAlias(data.accountId);
                _this.connectionTypes(data.connections);
                return _this.loginUsingSaml();
              } else {
                return _this.domainCheckComplete(true);
              }
            }).fail(function() {
              return _this.domainCheckComplete(true);
            });
          }
        };
      })(this));
    }
    window.setInterval((function(_this) {
      return function() {
        if (_this.authContext && _this.authContext().username !== void 0) {
          return _this.auth0.getSSOData(function(err, ssoData) {
            if (!ssoData.sso) {
              _this.clearAuthContextAndLocalStorage();
              if (_this.onLogout) {
                _this.onLogout();
              }
              return _this.showLoginWindow();
            }
          });
        }
      };
    })(this), 30000);
    return resultDeferred;
  };

  Authentication.prototype.logout = function(options) {
    options = $.extend({
      returnUrl: window.location.href
    }, options);
    this.clearUsernameAndConnections();
    return this.auth0.logout({
      federated: '',
      returnTo: options.returnUrl
    });
  };

  return Authentication;

})();

atlas.abort = function(options) {
  var env, tempAuth0;
  options = $.extend({
    callbackURL: window.location.origin,
    returnUrl: window.location.href
  }, options);
  env = internals.getEnvironment(options.env);
  tempAuth0 = new Auth0({
    domain: env.auth0Domain,
    clientID: env.auth0ClientID,
    callbackURL: options.callbackURL,
    responseType: 'token'
  });
  internals.localStorage.removeAll();
  return tempAuth0.logout({
    federated: '',
    returnTo: options.returnUrl
  });
};

var BrandBarViewModel;

BrandBarViewModel = (function() {
  function BrandBarViewModel(options, element) {
    options = $.extend({
      authContext: {},
      accountContext: {}
    }, options);
    this.accountContext = ko.asObservable(options.accountContext);
    this.authContext = ko.asObservable(options.authContext);
    this.phoneLink = ko.pureComputed((function(_this) {
      return function() {
        return 'tel:' + _this.accountContext().support.supportPhone.replace(/\./g, '');
      };
    })(this));
    this.shouldShowSupport = ko.pureComputed((function(_this) {
      return function() {
        var support;
        support = _this.accountContext().support;
        return !!support.chatServiceUrl || !!support.supportEmail || !!support.supportPhone || !!support.supportRequestUrl || !!support.featureRequestUrl || !!support.knowledgeBaseUrl || !!support.knowledgeBaseSearchUrl;
      };
    })(this));
    this.shouldShowUserInfo = ko.pureComputed((function(_this) {
      return function() {
        return _this.accountContext().branding.controlUserProfileUrl;
      };
    })(this));
    this.searchUrl = options.searchUrl;
    this.logoutHandler = (function(_this) {
      return function() {
        return internals._logout();
      };
    })(this);
  }

  return BrandBarViewModel;

})();

ko.components.register('brand-bar', {
  viewModel: {
    createViewModel: function(params, componentInfo) {
      return new BrandBarViewModel(params, componentInfo.element);
    }
  },
  template: {
    element: "atlas.brandBar"
  }
});

atlas.config = function() {
  return console.error("Config has been depricated in v2.0.0 of Atlas. Please refer to the documentation at https://assets.ctl.io/");
};

atlas.launch = function() {
  return console.error("Launch has been depricated in v2.0.0 of Atlas. Please refer to the documentation at https://assets.ctl.io/");
};

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

internals.environments = {
  dev: {
    auth0ClientID: '80H56eYxQ55YUcarbUzTSCWTpxYLVQap',
    auth0Domain: 'auth.dev.ctl.io',
    controlBaseUrl: 'https://control.dev.ctl.io'
  },
  ppe: {
    auth0ClientID: '3gUVBGdBqQeEP1F5AezRHDzgGlVDBdp9',
    auth0Domain: 'auth.ppe.ctl.io',
    controlBaseUrl: 'https://control.ppe.ctl.io'
  },
  prod: {
    auth0ClientID: 'xdEzsBqW51188Tm0b1QPCr9OEB5DX4Wc',
    auth0Domain: 'auth.ctl.io',
    controlBaseUrl: 'https://control.ctl.io'
  }
};

internals.getEnvironment = function(environment) {
  var env, i, len, missingKeys, providedKeys, requiredKey, requiredKeys;
  if (typeof environment === 'object') {
    requiredKeys = ['auth0ClientID', 'auth0Domain', 'controlBaseUrl'];
    providedKeys = Object.keys(environment);
    missingKeys = [];
    for (i = 0, len = requiredKeys.length; i < len; i++) {
      requiredKey = requiredKeys[i];
      if (indexOf.call(providedKeys, requiredKey) < 0) {
        missingKeys.push(requiredKey);
      }
    }
    if (missingKeys.length > 0) {
      throw "[Atlas] Environment must contain values for 'auth0ClientID', 'auth0Domain' and 'controlBaseUrl' (missing: " + (missingKeys.join(', ')) + "}).";
    }
    return environment;
  } else {
    env = internals.environments[environment];
    if (!env) {
      throw "[Atlas] supported environments are 'dev', 'ppe', or 'prod', you entered " + environment;
    }
    return env;
  }
};

var LaunchModel;

LaunchModel = (function() {
  LaunchModel.prototype.getBrandBarNode = function() {
    var bar;
    bar = $('brand-bar');
    if (bar.length < 1) {
      bar = $('<brand-bar></brand-bar>');
      bar.after($('account-switcher'));
    }
    bar.attr('params', '{ authContext: authContext, accountContext: accountContext, searchUrl: searchUrl, onLogout: onLogout }');
    return bar;
  };

  LaunchModel.prototype.getHeaderBrandingNodes = function() {
    var appleIcon, favicon, head, nodes, stylesheet, tileColor, tileImage;
    nodes = [];
    head = $('head');
    stylesheet = $('#accountStylesheet');
    if (stylesheet.length < 1) {
      stylesheet = $('<link id="accountStylesheet" data-bind="href: branding.cssUrl" type="text/css" rel="stylesheet" />');
      head.append(stylesheet);
    }
    nodes.push(stylesheet);
    favicon = $('#accountFavicon');
    if (favicon.length < 1) {
      favicon = $('<link id="accountFavicon" rel="icon" type="image/ico" data-bind="href: branding.favIconUrl" />');
      head.append(favicon);
    }
    nodes.push(favicon);
    appleIcon = $('#accountAppleIcon');
    if (appleIcon.length < 1) {
      appleIcon = $('<link id="accountAppleIcon" rel="apple-touch-icon" data-bind="href: branding.mobileIconUrl" />');
      head.append(appleIcon);
    }
    nodes.push(appleIcon);
    tileColor = $('#accountTileColor');
    if (tileColor.length < 1) {
      tileColor = $('<meta id="accountTileColor" name="msapplication-TileColor" data-bind="attr: {content:branding.headerBackgroundColor}">');
      head.append(tileColor);
    }
    nodes.push(tileColor);
    tileImage = $('#accountTileImage');
    if (tileImage.length < 1) {
      tileImage = $('<meta id="accountTileImage" name="msapplication-TileImage" data-bind="attr: {content: branding.mobileIconUrl}">');
      head.append(tileImage);
    }
    nodes.push(tileImage);
    return nodes;
  };

  LaunchModel.prototype.getAccountSwitcherNode = function() {
    var accountSwitcherNode;
    accountSwitcherNode = $('account-switcher');
    if (accountSwitcherNode.length < 1) {
      accountSwitcherNode = $('<account-switcher></account-switcher>');
      $('body').prepend(accountSwitcherNode);
    }
    accountSwitcherNode.attr('params', '{ accounts: accounts, loading: loadingAccounts, currentAccountAlias: currentAccountAlias }');
    return accountSwitcherNode;
  };

  LaunchModel.prototype.getMainNavNode = function() {
    var nav;
    nav = $('main-nav');
    if (nav.length < 1) {
      nav = $('<main-bar></main-bar>');
      nav.after($('brand-bar'));
    }
    nav.attr('params', '{ menus: menus, loading: loadingMenus, error: failedLoadingMenus, selectedItemId: selectedItemId }');
    return nav;
  };

  function LaunchModel(options) {
    var rootBrandingSupportInfo;
    options = $.extend({}, options);
    this.env = options.env;
    this.onLogout = options.onLogout;
    this.accountSwitcherModel = new AccountSwitcherViewModel();
    this.accountSwitcherModel.currentAccountAlias(ko.unwrap(options.accountAlias) || '');
    ko.applyBindings(this.accountSwitcherModel, this.getAccountSwitcherNode()[0]);
    if (ko.isObservable(options.accountAlias)) {
      options.accountAlias.subscribe((function(_this) {
        return function(newAlias) {
          return _this.accountSwitcherModel.currentAccountAlias(newAlias);
        };
      })(this));
    }
    rootBrandingSupportInfo = internals.localStorage.getRootBrandingSupportInfo() || {};
    this.brandingModel = new BrandingModel(rootBrandingSupportInfo.branding);
    this.supportModel = new SupportModel(rootBrandingSupportInfo.support);
    this.accountContext = ko.observable({
      accountAlias: void 0,
      branding: this.brandingModel,
      support: this.supportModel
    });
    this.getHeaderBrandingNodes().forEach((function(_this) {
      return function(n) {
        return ko.applyBindings(_this.accountContext, n[0]);
      };
    })(this));
    this.searchUrl = ko.observable();
    this.mainNavModel = new MainNavViewModel();
    this.mainNavModel.selectedItemId = options.mainNavId;
    ko.applyBindings(this.mainNavModel, this.getMainNavNode()[0]);
    this.accountSwitcherModel.currentAccountAlias.subscribe((function(_this) {
      return function(newAlias) {
        if (_this.accountContext && newAlias === _this.accountContext().accountAlias) {
          return;
        }
        _this.mainNavModel.loadingMenus(true);
        _this.mainNavModel.menus([]);
        atlas.ajax({
          type: 'get',
          url: _this.env.controlBaseUrl + "/api/navigation?accountAlias=" + newAlias,
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        }).done(function(menus) {
          _this.mainNavModel.loadingMenus(false);
          _this.mainNavModel.menus(menus.items);
        }).failed(function() {
          _this.mainNavModel.loadingMenus(false);
          return _this.mainNavModel.failedLoadingMenus(true);
        });
        return atlas.ajax({
          type: 'POST',
          url: _this.env.controlBaseUrl + "/api/accountContext?switchToAccountId=" + newAlias,
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        }).done(function(context) {
          _this.brandingModel = new BrandingModel(context.branding);
          _this.supportModel = new SupportModel(context.support);
          _this.searchUrl(_this.brandingModel.controlUrl + context.searchUrl);
          _this.accountContext({
            accountAlias: newAlias,
            branding: _this.brandingModel,
            support: _this.supportModel
          });
        });
      };
    })(this));
  }

  LaunchModel.prototype.launch = function() {
    var authData, fetchAccountContextFromCookie, fetchAccountHierarchy, resultDeferred;
    authData = internals.authContext();
    resultDeferred = $.Deferred();
    fetchAccountHierarchy = atlas.ajax({
      bearerToken: authData.bearerToken,
      url: this.env.controlBaseUrl + "/api/accounthierarchy",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(accounts) {
        _this.accountSwitcherModel.accounts([accounts]);
      };
    })(this));
    fetchAccountContextFromCookie = atlas.ajax({
      type: 'get',
      url: this.env.controlBaseUrl + "/api/accountContext",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(context) {
        if (_this.accountSwitcherModel.currentAccountAlias() === '') {
          _this.accountSwitcherModel.currentAccountAlias(context.currentAccountId);
        }
        _this.brandingModel = new BrandingModel(context.branding);
        _this.supportModel = new SupportModel(context.support);
        _this.accountContext({
          accountAlias: _this.accountSwitcherModel.currentAccountAlias(),
          branding: _this.brandingModel,
          support: _this.supportModel
        });
        _this.searchUrl(_this.brandingModel.controlUrl + context.searchUrl);
        ko.applyBindings({
          accountContext: _this.accountContext,
          authContext: internals.authContext,
          searchUrl: _this.searchUrl,
          onLogout: _this.onLogout
        }, _this.getBrandBarNode()[0]);
      };
    })(this));
    $.when(fetchAccountHierarchy, fetchAccountContextFromCookie).done((function(_this) {
      return function() {
        _this.accountSwitcherModel.loadingAccounts(false);
        _this.accountContext({
          accountAlias: _this.accountSwitcherModel.currentAccountAlias(),
          branding: _this.brandingModel,
          support: _this.supportModel
        });
        return resultDeferred.resolve(_this.accountContext);
      };
    })(this));
    atlas.ajax({
      type: 'get',
      url: this.env.controlBaseUrl + "/api/navigation",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(menus) {
        _this.mainNavModel.loadingMenus(false);
        _this.mainNavModel.menus(menus.items);
      };
    })(this)).failed((function(_this) {
      return function() {
        _this.mainNavModel.loadingMenus(false);
        return _this.mainNavModel.failedLoadingMenus(true);
      };
    })(this));
    return resultDeferred;
  };

  return LaunchModel;

})();

var Liftoff,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Liftoff = (function() {
  var LiftoffInstance, singletonInstance;

  function Liftoff() {}

  singletonInstance = null;

  Liftoff.instance = function() {
    return singletonInstance != null ? singletonInstance : singletonInstance = new LiftoffInstance();
  };

  LiftoffInstance = (function() {
    function LiftoffInstance() {
      this.afterLaunch = bind(this.afterLaunch, this);
      this.afterLogin = bind(this.afterLogin, this);
    }

    LiftoffInstance.prototype.hasAchievedLiftoff = false;

    LiftoffInstance.prototype.liftoff = function(options) {
      var promise;
      if (this.hasAchievedLiftoff) {
        throw "[Atlas] Liftoff has already been achieved! You may only call liftoff() once...";
      }
      promise = $.Deferred();
      this.options = this.processOptions(options);
      this.authModel = new Authentication(this.options);
      internals._logout = this.authModel.logout;
      this.authModel.login().done((function(_this) {
        return function(authData) {
          return _this.afterLogin(authData, promise);
        };
      })(this));
      return promise;
    };

    LiftoffInstance.prototype.afterLogin = function(authData, promise) {
      internals.authContext = authData;
      if (!this.options.includeAccountContextAndRenderShell) {
        return this.afterLaunch(authData, void 0, promise);
      } else {
        this.launchModel = new LaunchModel(this.options);
        return this.launchModel.launch().done((function(_this) {
          return function(accountData) {
            return _this.afterLaunch(authData, accountData, promise);
          };
        })(this));
      }
    };

    LiftoffInstance.prototype.afterLaunch = function(authData, accountData, promise) {
      promise.resolve({
        authContext: authData,
        accountContext: accountData
      });
      return this.hasAchievedLiftoff = true;
    };

    LiftoffInstance.prototype.processOptions = function(options) {
      options = $.extend({
        includeAccountContextAndRenderShell: true,
        callbackURL: window.location.origin,
        returnUrl: window.location.href
      }, options);
      if (this.validateOptions(options)) {
        options = this.normalizeOptions(options);
      }
      return options;
    };

    LiftoffInstance.prototype.logout = function(options) {
      return this.authModel.logout(options);
    };

    LiftoffInstance.prototype.validateOptions = function(options) {
      var availableEnvironments, environment;
      environment = options.env;
      availableEnvironments = Object.keys(internals.environments);
      if (indexOf.call(availableEnvironments, environment) < 0) {
        if (typeof environment === 'object') {
          return this.validateCustomEnvironment(environment);
        } else {
          throw "[Atlas] You must pass an environment to liftOff() as an option (i.e. { env: 'foo' } or { env: { auth0ClientID: '...', auth0Domain: '...', controlBaseUrl: '...' }}). Available environments are: " + (availableEnvironments.join(', ')) + ".";
        }
      }
      return true;
    };

    LiftoffInstance.prototype.normalizeOptions = function(options) {
      options = $.extend(true, {}, options);
      options.env = this.normalizeEnvironment(options.env);
      return options;
    };

    LiftoffInstance.prototype.validateCustomEnvironment = function(environment) {
      var i, len, missingKeys, providedKeys, requiredKey, requiredKeys;
      requiredKeys = ['auth0ClientID', 'auth0Domain', 'controlBaseUrl'];
      providedKeys = Object.keys(environment);
      missingKeys = [];
      for (i = 0, len = requiredKeys.length; i < len; i++) {
        requiredKey = requiredKeys[i];
        if (indexOf.call(providedKeys, requiredKey) < 0) {
          missingKeys.push(requiredKey);
        }
      }
      if (missingKeys.length > 0) {
        throw "[Atlas] Environment must contain values for 'auth0ClientID', 'auth0Domain' and 'controlBaseUrl' (missing: " + (missingKeys.join(', ')) + "}).";
      }
      return true;
    };

    LiftoffInstance.prototype.normalizeEnvironment = function(environment) {
      if (typeof environment === 'object') {
        return environment;
      } else {
        return internals.environments[environment];
      }
    };

    return LiftoffInstance;

  })();

  return Liftoff;

})();

atlas.liftOff = function(options) {
  var liftoffInstance;
  liftoffInstance = Liftoff.instance();
  return liftoffInstance.liftoff(options);
};

atlas.logout = function(options) {
  var liftoffInstance;
  liftoffInstance = Liftoff.instance();
  return liftoffInstance.logout(options);
};

atlas.liftoff = atlas.liftOff;

internals.localStorage = {
  removeAll: function() {
    localStorage.removeItem('atlas_sso');
    return localStorage.removeItem('atlas_bradning_support');
  },
  getSSOInfo: function() {
    var jsonString;
    jsonString = localStorage.getItem('atlas_sso');
    if (jsonString) {
      return JSON.parse(jsonString);
    }
  },
  storeSSOInfo: function(ssoInfo) {
    return localStorage.setItem('atlas_sso', JSON.stringify(ssoInfo));
  },
  getRootBrandingSupportInfo: function() {
    var jsonString;
    jsonString = localStorage.getItem('atlas_bradning_support');
    if (jsonString) {
      return JSON.parse(jsonString);
    }
  },
  storeRootBrandingSupportInfo: function(branding, support) {
    return localStorage.setItem('atlas_bradning_support', JSON.stringify({
      branding: branding,
      support: support
    }));
  }
};

var MainNavViewModel;

MainNavViewModel = (function() {
  function MainNavViewModel() {
    this.loadingMenus = ko.observable(true);
    this.failedLoadingMenus = ko.observable(false);
    this.menus = ko.observableArray([]);
    this.selectedItemId = ko.observable('');
  }

  return MainNavViewModel;

})();

  }));
}());


$.holdReady(true);
$.get("https://assets.ctl.io/atlas/2.0.0-beta.4/templates/atlas.tmpl.min.html", function(tmpl) {
  $("head")
    .append(tmpl);
  $.holdReady(false);
});

//# sourceMappingURL=atlas.js.map
